<template>
    <div class="max pcenter color-light bg-pos-2 bg-size-cover auto-scroll" :style="`backgroundImage: url(${bg.bgImg})`">

        <!--header-->
        <sec-header-widget v-bind="header_data" />

        <!--人口数据包的适用场景-->
        <section id="sec1" class="pad-h-2 mrg-v-2">
            <div class="rel container pad-h-1 pad-v-4 ">

                <!--遮罩-->
                <matteWidget v-bind="bg" />

                <h3 class="rel mrg-b-3 mrg-b-1-s">
                    <span class="fsize-1d5 fsize-d8-s">人口数据为以下应用场景提供数据支持</span>
                </h3>
                <article class="rel container fsize-1d3 pad-t-2 pjustify fsize-1d2-s pad-h-1-s" md>
                    <list-widget :text-list="introduce" />
                </article>
            </div>
        </section>

        <!--使用人口数据包的客户-->
        <section id="sec2">
            <sec-customer-widget />
        </section>

        <!--数据包亮点-->
        <section id="sec3" class="container rel pad-v-4 pad-h-2 mrg-v-2 mrg-v-0-s pad-h-1-s">

            <!--遮罩-->
            <matteWidget v-bind="bg" />

            <h2 class="rel mrg-b-3 mrg-b-1-s"><span class="fsize-1d5 fsize-1-s">数据包亮点</span></h2>
            <article class="rel container fsize-1d3 pad-t-2 pjustify fsize-1d2-s" md>
                <table-widget v-bind="data_character" />
            </article>
        </section>

        <!--数据内容-->
        <section id="sec4" class="container rel pad-v-4 pad-h-1 mrg-v-2 mrg-v-0-s">

            <!--遮罩-->
            <matteWidget />

            <h3 class="rel mrg-b-3 mrg-b-1-s">
                <span class="fsize-1d5 fsize-1-s">数据内容</span>
            </h3>
            <div class="rel container fsize-1d2 pad-t-2 pjustify" md>
                <tab-widget v-model="data_cont.val" :tags-data="data_cont.tagsData">
                    <article v-for="(tag,i) of data_cont.tagsData.tagList" :key="i" :slot="tag.id"
                             class="rel bg-color-dgray pad-2 round-sm">
                        <div class="alpha-d6 mrg-b-2 fsize-d9">{{tag.desc}}</div>
                        <list-widget v-if="tag.text_list" :text-list="tag.text_list" />
                        <slider-widget v-if="tag.slider_data" v-bind="tag.slider_data">
                            <img v-for="page of tag.slider_data.pages" :key="page.id" :slot="page.id"
                                 :src="page.src" />
                        </slider-widget>
                    </article>
                </tab-widget>
            </div>
        </section>

        <!--数据应用领域-->
        <section id="sec5">
            <sec-data-apply-widget :bg-color="bg.bgColor" />
        </section>

        <!--获取数据包-->
        <section id="sec6">
            <sec-data-package-widget :matte-data="bg" />
        </section>

        <!--footer-->
        <sec-footer-widget v-bind="footer_data" />
    </div>
</template>

<script>
    import TableWidget from "@/components/BTXUI/table/table-widget"
    import TabWidget from "@/components/BTXUI/tab/tab-widget"
    import SliderWidget from "@/components/BTXUI/slider/slider-widget"
    import ListWidget from "@/components/list-widget"
    import matteWidget from "@/components/matte-widget"
    import SecHeaderWidget from "@/components/sec-header-widget"
    import SecCustomerWidget from "@/components/sec-customer-widget"
    import SecDataPackageWidget from "@/components/sec-data-package-widget"
    import SecDataApplyWidget from "@/components/sec-data-apply-widget"
    import SecFooterWidget from "@/components/sec-footer-widget"

    const name = "popu";

    export default {
        name,
        components: {
            TableWidget,
            TabWidget,
            SliderWidget,
            ListWidget,
            matteWidget,
            SecHeaderWidget,
            SecCustomerWidget,
            SecDataPackageWidget,
            SecDataApplyWidget,
            SecFooterWidget
        },
        data(){
            const bg = {
                bgImg: require(`@/assets/img/daas_case/${name}_bg.jpg`),
                bgColor: "dblue"
            }

            return {

                //背景
                bg,

                //头部信息
                header_data: {
                    packageId: name,
                    mainNavData: {
                        logo: require('@/assets/img/logo/logo.png'),
                        navs: [
                            {
                                text: "首页",
                                link: "/"
                            },
                            {
                                text: "人口数据包的适用场景",
                                link: {
                                    chapter_id: "sec1",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "使用人口数据包的客户",
                                link: {
                                    chapter_id: "sec2",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据包亮点",
                                link: {
                                    chapter_id: "sec3",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据内容",
                                link: {
                                    chapter_id: "sec4",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据应用领域",
                                link: {
                                    chapter_id: "sec5",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "获取数据包",
                                link: {
                                    chapter_id: "sec6",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            }
                        ]
                    }
                },

                //概述
                introduce: [
                    "为基于人口的开店选址以及店铺经营方案提供数据支持",
                    "为基于旅游景区人口分布、规划及人群热度分析提供实时测算",
                    "为基于人口分布、人口流动的城市总体规划课题提供多维数据",
                    "为基于人口结构、人口喜好的区域空间改造评估提供数据支持",
                    "还包括：基于人口的城乡发展总体规划问题，商业网点与人口管理、配送及供应链预判管理问题，银行、保险业务网格化市场容量测算，基于人口的土地估值及土地拍卖评估等其他应用领域"
                ],

                //数据包特点
                data_character: {
                    thead: [
                        {
                            title: "<b class='color-yellow mrg-r-1'>·</b>实时更新的人口数据指标",
                            grow: 1
                        },
                        {
                            title: "<div class='alpha-d6 fsize-d9'>与统计局发布频度和人口普查5年周期相比，清华DaaS的人口数据按小时采集，按周、月更新。</div>",
                            grow: 2
                        }
                    ],
                    tbody: [
                        ["<b class='color-yellow mrg-r-1'>·</b>全国范围、多级粒度覆盖", "<div class='alpha-d6 fsize-d9'>与常见人口数据按城市或县区为颗粒度相比，清华DaaS的人口数据覆盖全部省市区县到每平方公里网格。</div>"],
                        ["<b class='color-yellow mrg-r-1'>·</b>人口相关的多维整体画像", "<div class='alpha-d6 fsize-d9'>与常见人口数据仅提供人口数量相比，清华DaaS的人口数据包含数量、结构、分布、喜好、消费、收入、通勤等区域人口全面画像。</div>"]
                    ],
                    colors: {
                        thead: "neutral",
                        row: {
                            head: "none",
                            odd: "rgba(134,134,134,.4)",
                            even: "neutral"
                        },
                        line: "none",
                        outline: "none"
                    }
                },

                //数据内容
                data_cont: {
                    val: "microcosmic",
                    tagsData: {
                        tagList: [
                            {
                                id: "microcosmic",
                                text: "微观数据",
                                desc: "地理范围：目标城市及下属所有区县1km²    起止时间：2019年9 - 至今    更新频率：按月更新",
                                text_list: [
                                    "常住人口（万人）",
                                    "常住人口去年同比增速（%）",
                                    "65岁以上常驻人口（万人）",
                                    "学生小孩人口（万人）",
                                    "商业人口（万人）",
                                    "居住人口（万人）",
                                    "学生儿童、劳动力人口、老年人口的人群比重（%）",
                                    "60、70、80、90后人群比重（%）",
                                    "……等相关数据"
                                ]
                            },
                            {
                                id: "macroscopic",
                                text: "宏观数据",
                                desc: "地理范围：目标城市及下属所有区县1km²   起止时间：2018.2 - 至今    更新频率：按月更新",
                                text_list: [
                                    "城镇居民人均消费支出（元）",
                                    "农村居民人均消费支出（元）",
                                    "人均食品消费支出（元）",
                                    "各支出数据对比的恩格尔系数",
                                    "城镇居民人均可支配收入（元）",
                                    "农村居民人均可支配收入（元）",
                                    "去年同比收入增速",
                                    "城乡居民收入比",
                                    "……等相关数据"
                                ]
                            },
                            {
                                id: "form",
                                text: "数据包形式",
                                desc: "数据包形式包括：“数据表格” 与 “可视化系统”",
                                slider_data: {
                                    pages: [
                                        {
                                            id: "a",
                                            src: require("@/assets/img/daas_case/f1.png")
                                        },
                                        {
                                            id: "b",
                                            src: require("@/assets/img/daas_case/f2.png")
                                        }
                                    ],
                                    view: {
                                        height: "auto"
                                    },
                                    showDot: {
                                        bottom: "15px",
                                        color: "#fff",
                                        act_color: "#ffcc00"
                                    },
                                    showFlipBtn: true,
                                    autoPlayDuration: 4000,
                                    loop: true
                                }
                            }
                        ],
                        colors: {
                            normal: {
                                text: "rgba(255,255,255,.4)",
                                bg: "rgba(0,0,0,.5)",
                            },
                            act: {
                                text: "#ffcc00",
                                bg: "dgray",
                            },
                            hover: {
                                text: "mgray",
                                bg: "rgba(0,0,0,.5)",
                            },
                        }
                    }
                },

                //底部信息
                footer_data: {
                    package: {
                        title: "实时人口数据包",
                        packageId: name,
                        packageName: "所有与人口数据相关的问题",
                        matteData: bg
                    }
                }

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/router/popu.vue